// extracted by mini-css-extract-plugin
export default {"automationObj":"AutomationObj_automationObj__G2doS","setData":"AutomationObj_setData__9MoQg"};